<template>
  <div class="page-block__inner">
    <div class="alert-view">
      <p v-if="message !== ''">
        {{ message }}
      </p>
    </div>
    <div class="c-btn-wrap">
      <router-link
        class="c-btn c-btn--back c-btn--back-left"
        :to="{ name: 'profile' }">
        戻る<span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      message: '',
    }
  },
  async mounted() {
    const { data } = await window.axios.get('/api/client/settlement/params')
    if (!data.is_available.result) {
      this.message = data.is_available.message
      this.$emit('time-limited')
    }
  },
}
</script>
